<template>
    <q-card class="column card">
        <q-card-section class="dashboard-card--header">
            {{ title }}
        </q-card-section>
        <!-- chart content goes here -->
        <slot />
    </q-card>
</template>

<script>
export default {
    name: 'ChartTemplate',
    props: {
        title: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
@import './dashboard.scss';

.card {
    min-height: 450px;
    height: auto;
}
</style>
